<template>
    <section class="p-5 card log-panel col-md-4 offset-md-4 col-10 offset-1 mt-md-0 mt-1">
        <div class="d-flex justify-content-between align-items-center mt-2">  
            <router-link  class="nav-link"  active-class="active" :to="{name: 'TestBarChart'}"> الإحصائيات </router-link>
            <router-link class="nav-link"  active-class="active" :to="{name: 'BarChart'}"> تسجيل مستخدم جديد </router-link>
        </div>
    </section>
    <section class="p-5 card  col-10 offset-1 mt-md-0 mt-1">
        <router-view></router-view>
    </section>
    
</template>

<script>
import GeneralModal from "@/components/Modal.vue";
import AlertModal from "@/components/AlertModal.vue";
import { mapGetters, mapActions } from 'vuex';
export default {
    name: "chartReports",
    components: {
        GeneralModal,
        AlertModal
    },
    data() {
        return {
            searchData: {
                pageNo: 1,
                pageSize: 25,
                appType: 0,
            },
            departs: [],
            reportData: [],
        }
    },
    created() {
        const currentDate = new Date();
        //this.searchData.to = currentDate.toISOString().split('T')[0];
        this.fetchOptions();
    },
    computed: {
        ...mapGetters(['getUser', 'getDeparts']),
        currentCountInView : function(){
            return this.searchData?.pageSize * this.searchData?.pageNo;
        }
    },
    methods: {
        /** */
        ...mapActions([
            'fetchUser',
            'fetchDeparts'
        ]),
        /********************************/
        /* */
        async fetchOptions() {
            if (this.getDeparts.length == 0) {
                await this.fetchDeparts();
            }
            if (this.getUser.hasOwnProperty("empNo") == 0) {
                await this.fetchUser();
            }
            this.departs = (this.getDeparts[0].id == 1) ? this.getDeparts.slice(1) : this.getDeparts;
        },
        /********************/

        // Fetch the report data with pagination for each section
        async getReport() {
            this.searchData.pageNo = 1;
            try {
                const response = await this.$axios.post(`api/employee/report/getillegalapplicants`, this.searchData);

                if (response?.data && response?.data.isSuccess) {
                    // Update the reportData with pagination information for each section
                    this.reportData = [response.data.data];
                } else {
                    this.$tempAlert(response?.data.msg ?? "حدثت مشكلة", 'warning');
                    this.reportData = [];
                }
            } catch (error) {
                console.error("Error fetching report:", error);
                if (error.response?.data) {
                    this.$tempAlert(error.response.data.msg, 'warning');
                }
            }
        },

        // Change the current page for a specific report section
        changePage(reportAppSection, newPageNo) {
            if (newPageNo >= 1 && newPageNo <= reportAppSection.totalPages) {
                reportAppSection.pageNo = newPageNo;
                this.getReportForSection(reportAppSection);
            }
        },

        /********************/
        // Fetch the report for a specific section based on the page number
        async getReportForSection(reportAppSection) {
            this.searchData.pageNo = reportAppSection.pageNo
            try {
                const response = await this.$axios.post(`api/employee/report/getillegalapplicants`, this.searchData);
                this.reportData = [response.data.data];
            } catch (error) {
                console.error("Error fetching report for section:", error);
            }
        },
        /********************/
        /* */
        resetValues() {
            this.reportData=[];
            this.searchData.pageNo = 1;
        },
        /********************/
    }
}
</script>
